import React from "react";
import { useSelector } from "react-redux";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { MARKS } from "@contentful/rich-text-types";
import "./TopSection.css";

const TopSection = () => {
  const aboutUsBanner = useSelector((state) => state.AboutUsBanner);

  const ensureSpacing = (doc) => {
    if (!doc || !doc.content) return doc;
    const clone = JSON.parse(JSON.stringify(doc));
    clone.content.forEach((block) => {
      if (!block.content) return;
      for (let i = 0; i < block.content.length; i++) {
        const node = block.content[i];
        const hasItalic =
          node.marks && node.marks.some((m) => m.type === "italic");
        if (!hasItalic) continue;
        if (i > 0) {
          const prev = block.content[i - 1];
          if (prev.value && !prev.value.endsWith(" ")) {
            prev.value += " ";
          }
        }
        if (i < block.content.length - 1) {
          const next = block.content[i + 1];
          if (
            next.value &&
            !next.value.startsWith(" ") &&
            !/^[,.\-;:!?]/.test(next.value)
          ) {
            next.value = " " + next.value;
          }
        }
      }
    });
    return clone;
  };

  const renderOptions = {
    renderMark: {
      [MARKS.BOLD]: (text) => (
        <strong style={{ fontWeight: "bold" }}>{text}</strong>
      ),
    },
  };

  return (
    <div
      className="container-fluid about-us-banner"
      style={{
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#001657",
        height: "50vh",
        minHeight: "280px",
        maxHeight: "400px",
        overflow: "hidden",
        display: "flex",
        position: "relative",
      }}
    >
      <div
        className="row text-center text-white w-100 align-items-center"
        style={{ height: "100%" }}
      >
        {/* LEFT TEXT */}
        <div
          className="col-lg-6 col-md-6 col-sm-12 text-start about-us-left"
          style={{ paddingLeft: "11%" }}
        >
          <h1 className="about-us-title">
            {aboutUsBanner?.AboutUsTitle || "ABOUT US"}
          </h1>
          <div className="about-us-description">
            {aboutUsBanner?.AboutUsContentText &&
            typeof aboutUsBanner.AboutUsContentText === "object"
              ? documentToReactComponents(
                  ensureSpacing(aboutUsBanner.AboutUsContentText),
                  renderOptions,
                )
              : aboutUsBanner?.AboutUsContentText || <span>At</span>}
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div
          className="col-lg-6 col-md-6 col-sm-12 position-relative about-us-right"
          style={{
            padding: 0,
            height: "100%",
            overflow: "hidden",
          }}
        >
          <img
            className="img-fluid h-100 w-100"
            src={
              aboutUsBanner?.BannerImage ||
              `${process.env.PUBLIC_URL}/aboutUs.jpg`
            }
            alt="About Us Banner"
            style={{
              objectFit: "cover",
              clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 15% 100%)",
              height: "100%",
              width: "100%",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TopSection;
